<template>
  <router-view />
</template>

<script>

export default {
  name: 'Invoices',
};
</script>
